import React, { useState } from 'react';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../constants';
import { ENTERPRISE_CARD_NAME, ENTERPRISE_CARD_ENABLED } from '../../../constants/ebon';

import { setPaymentType } from '../../../services/ebon/actions';

import { formatAmountCurrency } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import './PaymentSelectorComponent.scss';

const PaymentSelectorComponent = ({ i18n, balance, setPaymentType, cart, isEnterpriseCard }) => {
    const [selectedMethod, setSelectedMethod] = useState();

    const cartTotal = cart.reduce((acc, curr) => acc + curr.quantity * curr.value, 0);
    const isBalanceSufficient = balance >= cartTotal;

    const handleMethodChange = value => {
        setSelectedMethod(value);
        setPaymentType(value);
    };

    const renderEnterpriseCardMessage = () => {
        if (isBalanceSufficient) {
            const remainingBalance = balance - cartTotal;
            return convertHtmlToReactDomWithParams(
                i18n.TEXT_OK,
                ENTERPRISE_CARD_NAME,
                formatAmountCurrency(remainingBalance)
            );
        } else {
            const requiredAmount = cartTotal - balance;
            return convertHtmlToReactDomWithParams(
                i18n.TEXT_KO,
                formatAmountCurrency(requiredAmount),
                ENTERPRISE_CARD_NAME
            );
        }
    };

    return (
        <div className={`payment-selector ${isBalanceSufficient ? 'reverse' : ''}`}>
            <div className="form-row" onClick={() => handleMethodChange('creditCard')}>
                <div className="wrapper">
                    <div>
                        <label>
                            <input
                                type="radio"
                                id="creditCard"
                                name="creditCard"
                                value="creditCard"
                                checked={selectedMethod === 'creditCard'}
                            />
                            <span>{i18n.PAYMENT_CARD}</span>
                        </label>
                    </div>
                    <div className="balance-container">
                        <img src={`${STATIC_ROOT}/carte.png`} alt="logo" width="106" height="22" />
                    </div>
                </div>
            </div>

            {ENTERPRISE_CARD_ENABLED && !isEnterpriseCard && (
                <div
                    className={`form-row ${!isBalanceSufficient ? 'deactivated' : ''}`}
                    onClick={() => isBalanceSufficient && handleMethodChange('enterpriseCard')}>
                    <div className="wrapper">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    id="enterpriseCard"
                                    name="enterpriseCard"
                                    value="enterpriseCard"
                                    checked={selectedMethod === 'enterpriseCard'}
                                    disabled={!isBalanceSufficient}
                                />
                                <span>
                                    {convertHtmlToReactDomWithParams(
                                        i18n.LOYALTY_CARD,
                                        ENTERPRISE_CARD_NAME
                                    )}
                                </span>
                            </label>
                        </div>
                        <div className="balance-container">
                            <label className="balance-label">
                                {convertHtmlToReactDomWithParams(
                                    i18n.BALANCE,
                                    formatAmountCurrency(balance)
                                )}
                            </label>
                        </div>
                    </div>
                    <div className="info">{renderEnterpriseCardMessage()}</div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        i18n: state.i18n.page.EBON.PAYMENT_SELECTOR,
        balance: state.account.balance.credit
    };
};

const mapDispatchToProps = {
    setPaymentType
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSelectorComponent);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/PaymentSelectorComponent.js